if (!customElements.get('scroll-to')) {
  class ScrollTo extends HTMLElement {
    connectedCallback() {
      this.scrollTo = this.getAttribute('data-scroll-to');
      this.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(e) {
      e.preventDefault();
      const scrollTo = this.scrollTo;
      document.querySelector(scrollTo).scrollIntoView({ behavior: 'smooth' });
    }
  }

  customElements.define('scroll-to', ScrollTo);
}
